import Icons from 'components/Icons';
import Separator from 'components/Separator';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import actions from 'store/actions';
import { getErrorMessage, inputChange, validateEmail } from 'utils/modules/Handlers';
import CustomButton from 'components/CustomButton';
import './authForms.scss';
// Packages
import SuccessModal from 'components/SuccessModal';
import CustomTextInput from 'components/CustomTextInput';
import { toast } from 'react-toastify';
import ToastMessage from 'components/ToastMessage';
import { Signup } from 'routes/Authentication';


const AuthForms = ({ modal, setModal }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [viewPassword, setViewPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [form, setForm] = useState({
        email: {
            value: '',
            error: '',
        },
        password: {
            value: '',
            error: '',
        },
    });
    const [formForgotPassword, setFormForgotPassword] = useState({
        email: {
            value: '',
            error: '',
        },
    });
    const [selectedForm, setSelectedForm] = useState('login')

    const onChangeInput = ({ event, type, form }) => {
        const data = event.target.value;
        inputChange({ setForm: form, key: type, value: 'value', data: data })
    }

    const onSubmit = useCallback(async (event) => {
        event.preventDefault();

        const { email, password } = form
        let isValid = true

        if (!validateEmail(email.value)) {
            inputChange({ setForm: setForm, key: 'email', value: 'error', data: 'Entered email address is invalid' })
            isValid = false
        } else {
            inputChange({ setForm: setForm, key: 'email', value: 'error', data: '' })
        }

        if (password.value === '') {
            inputChange({ setForm: setForm, key: 'password', value: 'error', data: 'Password cannot be blank' })
            isValid = false
        } else {
            inputChange({ setForm: setForm, key: 'password', value: 'error', data: '' })
        }

        if (validateEmail(email.value) && password.value) {
            isValid = true
        }

        if (isValid) {
            try {
                await dispatch(actions.auth.login({ email: email.value, password: password.value }))
                dispatch(actions.auth.retrieveUser())
            } catch (error) {
                toast.error(<ToastMessage messages={getErrorMessage(error.response.data)} />, {
                    position: toast.POSITION.TOP_CENTER
                });
            }
        }

    }, [form])

    const onSubmitForgotPassword = useCallback(async (event) => {
        event.preventDefault();

        const { email } = formForgotPassword
        let isValid = true

        if (!validateEmail(email.value)) {
            inputChange({ setForm: setFormForgotPassword, key: 'email', value: 'error', data: 'Entered email address is invalid' })
            isValid = false
        } else {
            isValid = true
            inputChange({ setForm: setFormForgotPassword, key: 'email', value: 'error', data: '' })
        }

        if (isValid) {
            setLoading(true)
            try {
                await dispatch(actions.auth.resetPassword({ email: email.value })).then(() => {
                    toast.success('Reset password request sent! Please check your email.', {
                        position: toast.POSITION.TOP_CENTER
                    });
                    setLoading(false);
                    setModal(prev => !prev);
                })
            } catch (error) {
                toast.error(<ToastMessage messages={getErrorMessage(error.response.data)} />, {
                    position: toast.POSITION.TOP_CENTER
                });
                setLoading(false)
            }
        }

    }, [formForgotPassword])


    return (
        <div className='auth-forms-listing-detail'>
            <SuccessModal modal={modal} setModal={setModal}>
                {
                    selectedForm === 'login' &&
                    <div className='login-form'>
                        <p style={{ fontSize: 32, fontWeight: 700, margin: 0 }}>Sign in to continue</p>
                        <Separator height={24} />
                        <p style={{ fontSize: 20, fontWeight: 400, color: '#949494', margin: 0 }}>To continue with your showing request, sign in to your account.</p>
                        <Separator height={40} />
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', rowGap: 16 }}>
                            <CustomTextInput
                                size={'large'}
                                inputProps={{
                                    type: "email",
                                    placeholder: 'Email Address',
                                    id: 'email',
                                    onChange: (event) => onChangeInput({ event, type: "email", form: setForm }),
                                }}
                                style={{ width: 300 }}
                                error={form.email.error}
                            />
                            <CustomTextInput
                                size={'large'}
                                inputProps={{
                                    type: viewPassword ? 'text' : 'password',
                                    placeholder: 'Password',
                                    id: 'email',
                                    onChange: (event) => onChangeInput({ event, type: "password", form: setForm }),
                                }}
                                style={{ width: 300 }}
                                error={form.password.error}
                                rightSlot={<Icons.Eye style={{ cursor: 'pointer' }} color={viewPassword ? '#FAC91F' : '#808080'} width={15} onClick={() => setViewPassword(prev => !prev)} />}
                            />
                            <CustomButton text={'Sign In'} style={{ width: 300 }} action={onSubmit} size={'large'} />
                        </div>
                        <Separator height={16} />
                        <CustomButton text={'Forgot Password'} style={{ width: 300 }} type={'text'} action={() => setSelectedForm('forgot-password')} size={'large'} />
                        <p style={{ fontSize: 12, fontWeight: 400, color: '#949494', margin: '16px 0' }}>or</p>
                        <CustomButton text={'Create an account'} style={{ width: 300 }} type={'secondary'} action={() => setSelectedForm('signup')} size={'large'} />
                    </div>
                }

                {
                    selectedForm === 'signup' &&
                    <Signup modalSignup={true} setSelectedForm={setSelectedForm} />
                }

                {
                    selectedForm === 'forgot-password' &&
                    <div className='forgot-password-form'>
                        <p style={{ fontSize: 32, fontWeight: 700, margin: 0 }}>Forgot your password?</p>
                        <Separator height={24} />
                        <p style={{ fontSize: 20, fontWeight: 400, color: '#949494', margin: 0 }}>Please provide us your email and we will help you retrieve your account.</p>
                        <Separator height={40} />
                        <CustomTextInput
                            inputProps={{
                                type: "email",
                                placeholder: 'Email Address',
                                id: 'forgot-password-email',
                                onChange: (event) => onChangeInput({ event, type: "email", form: setFormForgotPassword }),
                            }}
                            size={'large'}
                            style={{ width: 300 }}
                            error={formForgotPassword.email.error}
                        />
                        <Separator height={16} />
                        <CustomButton text={'Submit'} style={{ width: 300 }} size={'large'} action={onSubmitForgotPassword} />
                        <Separator height={40} />
                        <p style={{ fontSize: 14, fontWeight: 400, color: '#808080', margin: 0 }}>Go back to <span style={{ color: '#FAC91F', cursor: 'pointer', fontWeight: 700, marginLeft: 10 }} onClick={() => setSelectedForm('login')}>Sign in</span></p>
                    </div>
                }
            </SuccessModal>
        </div>
    )
}


export default AuthForms;